import { createFileRoute } from "@tanstack/react-router"

import { LinkInvalid } from "#pages/login/invalid-link.tsx"

export const Route = createFileRoute("/_auth/invalid-link")({
  component: LinkInvalid,
})
